import { gql } from '@apollo/client';
import { AcitivityDetailsFragments } from '../ActivitySidebar';

export const GET_ACTIVITY_DETAILS = gql`
  query GetActivityDetails($activityId: String!, $activityDate: Date, $startDate: Date, $endDate: Date) {
    orgName
    vm {
      activity(activityId: $activityId) {
        activityId
        isActive
        isEnrollable
        isRestrictedActivity
        name
        startTime
        endTime
        startDate
        endDate
        isSuspended
        isHidden
        hasOpenRoster
        isEvent
        activityType
        allowRosterComments
        program {
          programId
          name
        }
        ...ActivityDescription
        publishedRoster(activityDate: $activityDate) {
          ...PublishedRoster
        }
        rosterTemplate(rosterDate: $activityDate) {
          ...ActivityRosterTemplate
        }
        rosterTemplates {
          rosterTemplateId
          rosterDate
        }
        effectiveAddressRevealBeforeDays
        effectiveAddressHideAfterDays
        activityLocation {
          ...ActivityLocation
        }
        activityRemoteLocation {
          ...ActivityRemoteLocation
        }
        sessions(includeOneOff: true, activityDate: $activityDate) {
          ...ActivitySession
        }
        activityAttachments {
          ...ActivitiesActivityAttachments
        }
        cancelledActivities {
          ...CancelledActivities
        }
        nextUntil(until: $endDate)
        occurrencesBetween(from: $startDate, until: $endDate)
        draftRoster(activityDate: $activityDate) {
          ...DraftRoster
        }
      }
    }
  }
  ${AcitivityDetailsFragments.cancelledActivities}
  ${AcitivityDetailsFragments.publishedRoster}
  ${AcitivityDetailsFragments.session}
  ${AcitivityDetailsFragments.upcomingRoster}
  ${AcitivityDetailsFragments.location}
  ${AcitivityDetailsFragments.attachment}
  ${AcitivityDetailsFragments.description}
  ${AcitivityDetailsFragments.rosterTemplate}
  ${AcitivityDetailsFragments.draftRoster}
`;
